let environment;
const host = window.location.hostname == 'localhost' ? `${window.location.hostname}:${window.location.port}` : window.location.hostname;

switch (host) {
	case 'dynamicmail-cc.optimove.net':
	case 'dynamicmail.optimove.net': {
		environment = {
			production: true,
			name: 'prod',
			GAtag: 'UA-140450090-1',
			webComponentUrl: 'https://dynamicmail-wc-qa.optimove.net',
			dmAssetsDomain: 'https://dm-assets.optimove.net',
			apiURL: '',
			// Optimove Prod
			// newApiURL: 'https://dm-api.optimove.net'
			// Cloudcore-prod-us
			newApiURL: 'https://dm-api-cc.optimove.net'
		};
		break;
	}

	case 'localhost:3000': // Opti-x localhost
	case 'dynamicmail-qa-cc.optimove.net':
	case 'dynamicmail-qa.optimove.net':
	case 'dynamicmail-wc-qa.optimove.net': {
		environment = {
			production: false,
			name: 'qa',
			GAtag: 'UA-140450090-2',
			webComponentUrl: 'https://dynamicmail-wc-qa.optimove.net',
			dmAssetsDomain: 'https://dm-assets.optimove.net',
			apiURL: '',
			// Optimove:
			// newApiURL: 'https://dm-api-qa.optimove.net'
			// Cloudcore
			newApiURL: 'https://dm-api-qa-cc.optimove.net'
		};
		break;
	}

	default: {
		environment = {
			production: false,
			name: 'dev',
			GAtag: 'UA-140450090-2',
			webComponentUrl: 'https://dynamicmail-wc-qa.optimove.net',
			// webComponentUrl: 'http://127.0.0.1:3333',
			dmAssetsDomain: 'https://dm-assets.optimove.net',
			apiURL: 'https://dynamicmail-front-diamond.optimove.net',
			// Locahost:
			newApiURL: 'http://127.0.0.1:3002'
			// Cloudcore QA:
			// newApiURL: 'https://dm-api-qa-cc.optimove.net'
			// Cloudcore Prod:
			// newApiURL: 'https://dm-api-cc.optimove.net'
			// Optimove QA:
			// newApiURL: 'https://dm-api-qa.optimove.net'
		};
		break;
	}
}
export { environment };
